/**
 * Dependencies: jQuery, MagnificPopup
 */
(function($) {
  var SessionNotify = {
    open() {
      return $.magnificPopup.open({
        type: 'inline',
        items: {
          src: '#session_notify'
        },
        modal: true,
        mainClass: 'mfp-zoom-up',
        removalDelay: 200,
        callbacks: {
          open() {
            $(document).triggerHandler('SessionNotifyOpen');
          },
          close() {
            $(document).triggerHandler('SessionNotifyClosed');
          }
        }
      });
    },

    close() {
      return $.magnificPopup.instance.close();
    }
  };

  if (undefined === window.TL)
    window.TL = {};

  if (undefined === window.TL.ui)
    window.TL.ui = {};

  window.TL.ui = {
    ...window.TL.ui,
    SessionNotify: SessionNotify
  };
})(jQuery);